export const environment = {
  production: false,
  envName: 'Development',
  // Shown next to the environment badge on System Health; the backend is shared, so only the UI knows its tenant.
  tenantLabel: '',
  // ControlTower API base URL - set to APIM gateway URL for SWA deployments.
  // Pipeline replaces https://controltower-dev-jwisitgpr74k6-gjb0fchvgkbnamgp.b01.azurefd.net at build time with the actual APIM gateway URL.
  // For local dev (Aspire/Tilt), use environment.local.aspire.ts or environment.local.k8s.ts instead.
  apiUrl: 'https://controltower-dev-jwisitgpr74k6-gjb0fchvgkbnamgp.b01.azurefd.net',

  // AKS cluster details (for kubectl port-forward instructions)
  aksResourceGroup: 'ct-dev',
  aksClusterName: 'aks-controltower-dev-jwisitgpr74k6',
  // (APIM routes /api/metadata/* to the metadata service ingress).
  metadataApiUrl: 'https://controltower-dev-jwisitgpr74k6-gjb0fchvgkbnamgp.b01.azurefd.net',
  // Validation service data API - reached through the ControlTower passthrough proxy
  // (VsDataServiceController), so vs-data-service stays off the public internet.
  validationServiceUrl: 'https://controltower-dev-jwisitgpr74k6-gjb0fchvgkbnamgp.b01.azurefd.net/api/vs-data-service',

  // Azure Managed Grafana dashboard URL
  grafanaUrl:
    'https://grfn-ct-dev-jwisitgpr74-c2cad8cubpgfbpg4.wus2.grafana.azure.com',

  // Entitlement portal URL for requesting Grafana access
  grafanaAccessUrl:
    'https://coreidentity.microsoft.com/manage/Entitlement/entitlement/controltower-44tc',

  // Feature flags
  enableAuthInterceptorLogging: true,
  logLevel: 'debug' as const,

  // MSAL (Microsoft Authentication Library) Configuration
  msal: {
    clientId: '0cc68201-58e0-48a6-a589-24c39b9d2745',
    authority:
      'https://login.microsoftonline.com/72f988bf-86f1-41af-91ab-2d7cd011db47',
    scopes: [
      'User.Read',
      'api://0cc68201-58e0-48a6-a589-24c39b9d2745/access_as_user',
    ],
    navigateToLoginRequestUrl: true,
    // sessionStorage (not localStorage): tokens are cleared when the browser session ends,
    // mitigating token exposure on shared workstations/profiles (TM Finding 25 / CWE-922).
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
    interactionType: 'redirect',
    loginHint: '',
    extraQueryParameters: {},
    extraScopesToConsent: [],
    knownAuthorities: [],
    cloudDiscoveryMetadata: '',
    authorityMetadata: '',
  },
};
